//  services to fetch and patch constraints and weightage

import axios from "axios";
// import { dummyStepsDataJson } from "./data";
import { baseUrl } from "../../../../../Redux/App/app.actions";
// const url = "example";
export const getNestedStepsDataApi = async (setLoading) => {
  try {
    setLoading(true);
    const res = await axios.get(`${baseUrl}/b1/get_categories`);
    console.log(res);
    const data = res?.data;
    if (data) {
      return data;
    } else {
      console.log("No Data Found");
    }
  } catch (error) {
    console.log(error);
  } finally {
    setLoading(false);
  }
};

export const getTentativeBurdenMixApi = async (setLoading) => {
  try {
    setLoading(true);
    const res = await axios.post(`${baseUrl}/b1/transform`);
    console.log(res);
    const data = res?.data;
    if (data) {
      for (let key in data) {
        if (data[key] === 0) {
          delete data[key];
        }
      }
      return { success: true, data };
    } else {
      console.log("No Data Found");
    }
  } catch (error) {
    console.log(error);
    return {
      success: false,
      message: error?.response?.data?.error || "Unexpected Error",
    };
  } finally {
    setLoading(false);
  }
};

export const updateNestedStateDataApi = async (payload) => {
  try {
    console.log(payload);
    const res = await axios.post(`${baseUrl}/b1/update_categories`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    console.log(res);
    const data = res?.data;
    if (res.status === 200 && data) {
      return { message: res.data.message, status: true };
    } else {
      console.log("Error while updating data");
    }
  } catch (error) {
    console.log(error);
  }
};
